import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// No StrictMode: its double-mounted effects would release a reviewer's application lock right after it is taken.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
